import { render, staticRenderFns } from "./FrontaleDx.vue?vue&type=template&id=707963d0&"
import script from "./FrontaleDx.vue?vue&type=script&lang=js&"
export * from "./FrontaleDx.vue?vue&type=script&lang=js&"
import style0 from "./FrontaleDx.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports